import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgMinusCircleFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-4 0a1 1 0 0 1-1 1H7a1 1 0 1 1 0-2h10a1 1 0 0 1 1 1Z", fill: color }));
};
export default factorySvgIcon(SvgMinusCircleFilled);
//# sourceMappingURL=SvgMinusCircleFilled.js.map